
import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _WITHDRAWAL_URL = "withdrawal";

export async function getWithdrawalList(params) {
    const response = await ApiBase.get(`${_WITHDRAWAL_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function updateStatus(id, params) {
    const response = await ApiBase.post(`${_WITHDRAWAL_URL}/${id}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_UPDATE_WITHDRAWAL_STATUS"))

    return response;
}